import { getCalendario, getEventoFecha, getEventoMes, getDetalleGrupo, getViajeReferencia, getMovimientosCuentaCliente, getDocuementosCuentaPaquete, getDetallePaqueteRefencia, getPaqueteViajeFecha } from "../services/serviceViaje"
import { getNotifiacionesClientePaquete } from "../services/notificacionesServices"
import { getComprasItemsPaquete, newCompraItem, deleteCompraItem, updateCompraItem, newCompraItemGrupal, getItemsPagarGrupo, updateAutorizacionCompraItem } from "../services/comprasService"
import { postWalletDocument, getWallet, getWalletDocument, deleteWalletDocument, updateWalletDocument, getDocuemtVoucher, getDocuemtVoucherDowload } from "../services/documentosService"
import { FECHACALENDARIO } from "../constant/localStorage"

const dataInicial = {
  exito: 0,
  semanas: [],
  eventos: [],
  eventosMes: [],
  grupo: [],
  grupoDetail: {},
  fecha: "",
  fechaCorta: "",
  cliente: {},
  movimientos: [],
  notificaciones: [],
  pasajeros: [],
  compras: [],
  comprasDetalle: {},
  wallet: [],
  walletDocument: 0,
  ItemsPagarGrupo: {},
  vouchers: [],
  voucherDocument: 0,
};

const GET_VIAJE_CALENDARIO_CLEAR_STATE = "GET_VIAJE_CALENDARIO_CLEAR_STATE"
const GET_VIAJE_CALENDARIO_SEMANAS = "GET_VIAJE_CALENDARIO_SEMANAS"
const GET_VIAJE_CALENDARIO_EVENTOS = "GET_VIAJE_CALENDARIO_EVENTOS"
const GET_VIAJE_CALENDARIO_GRUPOS = "GET_VIAJE_CALENDARIO_GRUPOS"
const OBTENER_VIAJE_CALENDARIO_FECHA = "OBTENER_VIAJE_CALENDARIO_FECHA"
const GET_VIAJE_CALENDARIO_CLIENTE = "GET_VIAJE_CALENDARIO_CLIENTE"
const GET_VIAJE_CALENDARIO_MOVIMIENTOS = "GET_VIAJE_CALENDARIO_MOVIMIENTOS"
const GET_VIAJE_CALENDARIO_NOTIFICACIONES = "GET_VIAJE_CALENDARIO_NOTIFICACIONES"
const GET_VIAJE_CALENDARIO_DOCUMENTOS_CUENTA = "GET_VIAJE_CALENDARIO_DOCUMENTOS_CUENTA"
const GET_VIAJE_CALENDARIO_COMPRAS_COTIZACION = "GET_VIAJE_CALENDARIO_COMPRAS_COTIZACION"
const POST_VAIJE_CALENDARIO_COMPRAS_ITEM_NEW = "POST_VAIJE_CALENDARIO_COMPRAS_ITEM_NEW"
const POST_VUAJE_CALENDARIO_COMPRAS_ITEM_GRUPO_NEW = "POST_VUAJE_CALENDARIO_COMPRAS_ITEM_GRUPO_NEW"
const GET_VIAJE_CALENDARIO_COMPRAS_ITEM_PAGAR_GRUPO = "GET_VIAJE_CALENDARIO_COMPRAS_ITEM_PAGAR_GRUPO"
const GET_VIAJE_CALENDARIO_COMPRAS_ITEM_DETALLE = "GET_VIAJE_CALENDARIO_COMPRAS_ITEM_DETALLE"
const DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM = "DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM"
const DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM_AUTORIZACION = "DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM_AUTORIZACION"
const PUT_VIAJE_CALENDARIO_COMPRAS_ITEM = "PUT_VIAJE_CALENDARIO_COMPRAS_ITEM"
const POST_VIAJE_CALENDARIO_WALLET_NEW = "POST_VIAJE_CALENDARIO_WALLET_NEW"
const GET_VIAJE_CALENDARIO_WALLET_PAQUETE = "POST_VIAJE_CALENDARIO_WALLET_PAQUETE"
const GET_VIAJE_CALENDARIO_WALLET_DOCUMENT = "GET_VIAJE_CALENDARIO_WALLET_DOCUMENT"
const PUT_VIAJE_CALENDARIO_WALLET_DOCUMENT = "PUT_VIAJE_CALENDARIO_WALLET_DOCUMENT"
const DELETE_VIAJE_CALENDARIO_WALLET_DOCUMENT = "DELETE_VIAJE_CALENDARIO_WALLET_DOCUMENT"
const GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT = "GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT"
const GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT_DOWLOAD = "GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT_DOWLOAD"


export default function viajeCalendarioReducer(state = dataInicial, action) {
  switch (action.type) {
    case GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT_DOWLOAD: 
      return { ...state, voucherDocument: action.payload.voucherDocument }
    case GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT: 
      return { ...state, vouchers: action.payload.vouchers }
    case DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM_AUTORIZACION:
      return { ...state, exito: action.payload.exito }
    case GET_VIAJE_CALENDARIO_COMPRAS_ITEM_PAGAR_GRUPO: 
      return { ...state, ItemsPagarGrupo: action.payload.ItemsPagarGrupo }
    case POST_VUAJE_CALENDARIO_COMPRAS_ITEM_GRUPO_NEW:
      return { ...state, exito: action.payload.exito }
    case DELETE_VIAJE_CALENDARIO_WALLET_DOCUMENT:
      return { ...state, exito: action.payload.exito }
    case PUT_VIAJE_CALENDARIO_WALLET_DOCUMENT:
      return { ...state, exito: action.payload.exito }
    case GET_VIAJE_CALENDARIO_WALLET_DOCUMENT:
      return { ...state, walletDocument: action.payload.walletDocument }
    case GET_VIAJE_CALENDARIO_WALLET_PAQUETE:
      return { ...state, wallet: action.payload.wallet }
    case POST_VIAJE_CALENDARIO_WALLET_NEW:
      return { ...state, exito: action.payload.exito }
    case PUT_VIAJE_CALENDARIO_COMPRAS_ITEM:
      return { ...state, exito: action.payload.exito }
    case DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM:
      return { ...state, exito: action.payload.exito }
    case GET_VIAJE_CALENDARIO_COMPRAS_ITEM_DETALLE:
      return { ...state, comprasDetalle: action.payload.comprasDetalle }
    case POST_VAIJE_CALENDARIO_COMPRAS_ITEM_NEW:
      return { ...state, exito: action.payload.exito }
    case GET_VIAJE_CALENDARIO_COMPRAS_COTIZACION:
      return { ...state, compras: action.payload.compras }
    case GET_VIAJE_CALENDARIO_DOCUMENTOS_CUENTA:
      return { ...state, pasajeros: action.payload.pasajeros }
    case GET_VIAJE_CALENDARIO_NOTIFICACIONES:
      return { ...state, notificaciones: action.payload.notificaciones }
    case GET_VIAJE_CALENDARIO_MOVIMIENTOS:
      return { ...state, movimientos: action.payload.movimientos }
    case GET_VIAJE_CALENDARIO_CLIENTE:
      return { ...state, cliente: action.payload.cliente }
    case OBTENER_VIAJE_CALENDARIO_FECHA:
      return { ...state, fecha: action.payload.fecha, fechaCorta: action.payload.fechaCorta }
    case GET_VIAJE_CALENDARIO_GRUPOS:
      return { ...state, grupo: action.payload.grupo, grupoDetail: action.payload.grupoDetail }
    case GET_VIAJE_CALENDARIO_EVENTOS:
      return { ...state, eventos: action.payload.eventos, fecha: action.payload.fecha, fechaCorta: action.payload.fechaCorta };
    case GET_VIAJE_CALENDARIO_SEMANAS:
      return { ...state, semanas: action.payload.semanas, eventosMes: action.payload.eventosMes };
    case GET_VIAJE_CALENDARIO_CLEAR_STATE:
      return {
        ...state,
        semanas: action.payload.semanas,
        eventos: action.payload.eventos,
        eventosMes: action.payload.eventosMes,
        fecha: action.payload.fecha,
        fechaCorta: action.payload.fechaCorta,
      };
    default:
      return state;
  }
}

export const obtenerVouchersDocumentoDowload = ({ idCompra }) => async (dispatch) => {
  return await getDocuemtVoucherDowload({ idCompra }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT_DOWLOAD,
      payload: {
        voucherDocument: 1
      }
    })
    return Response
  }).then(Error => {
    return Error
  })
}

export const obtenerVouchersDocumentoPaquete = ({ idPaquete }) => async (dispatch) => {
  return await getDocuemtVoucher({ idPaquete }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT,
      payload: {
        vouchers: Response
      }
    })
  }).catch(Error => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_VOUCHER_DOCUMENT,
      payload: {
        vouchers: []
      }
    })
  })
}

export const AutorizarAgenteCompraItem = ({ idCompra }) => async (dispatch) => {
  return await updateAutorizacionCompraItem({ idCompra }).then(Response => {
    dispatch({
      type: DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM_AUTORIZACION,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}

export const obtenerComprasPagarGrupo = ({ idTpoCompra, fechaViaje, nombrePaquete }) => async (dispatch) => {
  return await getItemsPagarGrupo({ idTpoCompra, fechaViaje, nombrePaquete }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_COMPRAS_ITEM_PAGAR_GRUPO,
      payload: {
        ItemsPagarGrupo: Response
      }
    })
  }).catch(Error => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_COMPRAS_ITEM_PAGAR_GRUPO,
      payload: {
        ItemsPagarGrupo: {}
      }
    })
  })
}

export const actualizarDocumento = ({ idDocumento, Nombre, Imagen }) => async (dispatch) => {
  return await updateWalletDocument({ idCatDocumentoPaquete: idDocumento, Nombre, Imagen }).then(Response => {
    dispatch({
      type: PUT_VIAJE_CALENDARIO_WALLET_DOCUMENT,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}

export const eliminarDocumento = ({ idDocumento }) => async (dispatch) => {
  return await deleteWalletDocument({ idCatDocumentoPaquete: idDocumento }).then(Response => {
    dispatch({
      type: DELETE_VIAJE_CALENDARIO_WALLET_DOCUMENT,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}

export const obtenrWalletDocumento = ({ idDocumento }) => async (dispatch) => {
  return await getWalletDocument({ idCatDocumentoPaquete: idDocumento }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_WALLET_DOCUMENT,
      payload: {
        walletDocument: 1
      }
    })
    return Response
  }).then(Error => {
    return Error
  })
}

export const obtenrWalletPaquete = ({ idPaquete }) => async (dispatch) => {
  return await getWallet({ idPaquete }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_WALLET_PAQUETE,
      payload: {
        wallet: Response
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}

export const nuevoDocumento = ({ idPaquete, Imagen, Nombre }) => async (dispatch) => {
  return await postWalletDocument({ idPaquete, Imagen, Nombre }).then(Response => {
    dispatch({
      type: POST_VIAJE_CALENDARIO_WALLET_NEW,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    return Error
  })
}

export const obtenerComprasDetalle = ({ idPaquete, referencia }) => async (dispatch) => {
  return await getDetallePaqueteRefencia({ idPaquete, referencia }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_COMPRAS_ITEM_DETALLE,
      payload: {
        comprasDetalle: Response
      }
    })
  }).catch(Error => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_COMPRAS_ITEM_DETALLE,
      payload: {
        comprasDetalle: {}
      }
    })
  })
}
export const eliminarCompraItem = ({ idCompra }) => async (dispatch) => {
  return await deleteCompraItem({ idCompra }).then(Response => {
    dispatch({
      type: DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    dispatch({
      type: DELETE_VIAJE_CALENDARIO_COMPRAS_ITEM,
      payload: {
        exito: 0
      }
    })
    return Error
  })
}
export const actulizarCompraItem = ({ idCompra, idMoneda, MontoProveedor }) => async (dispatch) => {
  return await updateCompraItem({ idCompra, idMoneda, MontoProveedor }).then(Response => {
    dispatch({
      type: PUT_VIAJE_CALENDARIO_COMPRAS_ITEM,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    dispatch({
      type: PUT_VIAJE_CALENDARIO_COMPRAS_ITEM,
      payload: {
        exito: 0
      }
    })
    return Error
  })
}
export const crearCompraItemGrupo = ({ nombrePaquete, fechaViaje, idTipoCompra }) => async (dispatch) => {
  return await newCompraItemGrupal({ nombrePaquete, fechaViaje, idTipoCompra }).then(Response => {
    dispatch({
      type: POST_VUAJE_CALENDARIO_COMPRAS_ITEM_GRUPO_NEW,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    dispatch({
      type: POST_VUAJE_CALENDARIO_COMPRAS_ITEM_GRUPO_NEW,
      payload: {
        exito: 0
      }
    })
    return Error
  })
}

export const crearCompraItem = ({ idCuenta, idMoneda, idPaquete, idTipoCompra, MontoProveedor }) => async (dispatch) => {
  return await newCompraItem({ idCuenta, idMoneda, idPaquete, idTipoCompra, MontoProveedor }).then(Response => {
    dispatch({
      type: POST_VAIJE_CALENDARIO_COMPRAS_ITEM_NEW,
      payload: {
        exito: 1
      }
    })
    return Response
  }).catch(Error => {
    dispatch({
      type: POST_VAIJE_CALENDARIO_COMPRAS_ITEM_NEW,
      payload: {
        exito: 0
      }
    })
    return Error
  })
}
export const obtenerComprasItemPaquete = ({ IdPaquete }) => async (dispatch) => {
  return await getComprasItemsPaquete({ IdPaquete }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_COMPRAS_COTIZACION,
      payload: {
        compras: Response
      }
    })
  }).catch(Error => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_COMPRAS_COTIZACION,
      payload: {
        compras: []
      }
    })
  })
}

export const obtenerPasajerosDocumentos = ({ idCuenta, idPaquete }) => async (dispatch) => {
  return await getDocuementosCuentaPaquete({ idCuenta, idPaquete }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_DOCUMENTOS_CUENTA,
      payload: {
        pasajeros: Response
      }
    })
  }).catch(Error => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_DOCUMENTOS_CUENTA,
      payload: {
        pasajeros: []
      }
    })
  })
}

export const obtenerClienteAction = ({ referencia }) => async (dispatch) => {
  return await getViajeReferencia({ referencia }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_CLIENTE,
      payload: {
        cliente: Response
      }
    })
  }).catch(Error => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_CLIENTE,
      payload: {
        cliente: {}
      }
    })
  })
}

export const obtenerGrupoAction = ({ fecha, nombre }) => async (dispatch, getState) => {
  const grupoDetail = await getDetalleGrupo({ fecha, nombre })
  dispatch({
    type: GET_VIAJE_CALENDARIO_GRUPOS,
    payload: {
      grupo: (grupoDetail?.Detalles) ? grupoDetail.Detalles : [],
      grupoDetail: grupoDetail
    }
  })
}

export const obtenerCalendarioAction = (anho, mes) => async (dispatch) => {
  const semanas = await getCalendario({ anho, mes });
  const eventosMes = await getEventoMes({ anho, mes });
  dispatch({
    type: GET_VIAJE_CALENDARIO_SEMANAS,
    payload: {
      semanas: semanas,
      eventosMes: eventosMes
    },
  });
  return semanas;
}

export const obtenerEventosAction = ({fecha, fechaSelect}) => async (dispatch) => {
  localStorage.setItem(FECHACALENDARIO, fechaSelect);
  return await getPaqueteViajeFecha({ FechaSalida: fecha }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_EVENTOS,
      payload: {
        eventos: Response,
        fecha: fechaSelect,
        fechaCorta: fecha,
      },
    });
    return Response
  }).catch(Error => {
    return Error
  })
};

export const obtenerFecha = () => async (dispatch) => {
  if (localStorage.getItem(FECHACALENDARIO)) {
    const fechaStorage = localStorage.getItem(FECHACALENDARIO)
    dispatch({
      type: OBTENER_VIAJE_CALENDARIO_FECHA,
      payload: {
        fecha: fechaStorage,
        fechaCorta: `${fechaStorage.split('/')[1]}${fechaStorage.split('/')[0]}${fechaStorage.split('/')[2]}`,
      }
    })
  }
  else
    dispatch({
      type: OBTENER_VIAJE_CALENDARIO_FECHA,
      payload: {
        fecha: "",
        fechaCorta: ""
      }
    })
}

export const clearCalendarioState = () => async (dispatch) => {
  dispatch({
    type: GET_VIAJE_CALENDARIO_CLEAR_STATE,
    payload: dataInicial,
  });
};

export const obtenerMovimientoReferencia = ({ referencia }) => async (dispatch) => {
  return await getMovimientosCuentaCliente({ Referencia: referencia, Pagina: 1, Registros: 10 }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_MOVIMIENTOS,
      payload: {
        movimientos: Response,
      },
    });
  }).catch(Error => {
    return []
  })
}

export const obtenerNotificacionesPaquete = ({ idCuenta, idPaquete }) => async (dispatch) => {
  return await getNotifiacionesClientePaquete({ idCuenta, idPaquete }).then(Response => {
    dispatch({
      type: GET_VIAJE_CALENDARIO_NOTIFICACIONES,
      payload: {
        notificaciones: Response,
      },
    });
  }).catch(Error => {
    return []
  })
}
